import React, { FC } from 'react';
type IProps = {
    innerText: string;
    isLoading?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    id?: string;
    className?: string;
    type?: 'button' | 'submit' | 'reset';
    dataCy?: any;
};
const ButtonBase: FC<IProps> = ({ innerText, isLoading, onClick, id, disabled, className, type, dataCy }) => {
    return (
        <button
            onClick={onClick}
            type={type}
            disabled={isLoading || disabled}
            id={id}
            className={`btn ${className} ${
                disabled || isLoading
                    ? `cursor-not-allowed border-gray-400 bg-gray-400 text-white hover:border-gray-400 hover:bg-gray-400`
                    : `flex h-10  items-center justify-center border-custom-500 bg-custom-500 text-white  hover:border-custom-600 hover:bg-custom-600 hover:text-white focus:border-custom-600 focus:bg-custom-600 focus:text-white focus:ring focus:ring-custom-100 active:border-custom-600 active:bg-custom-600 active:text-white active:ring active:ring-custom-100 dark:ring-custom-400/20`
            }`}
            data-cy={dataCy}
        >
            {innerText}
        </button>
    );
};

export default ButtonBase;

//
